export default __webpack_public_path__ + "static/media/op_right.9034585e.png";